import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { SyncCartFavoritesOnLogin } from '@/components/SyncCartFavoritesOnLogin'
import { AutofillPrompt } from '@/components/AutofillPrompt'
import { ScrollToTop } from '@/components/ScrollToTop'
import { ScrollUpButton } from '@/components/ScrollUpButton'
import WarehouseSelectionModal from '@/components/WarehouseSelectionModal'
import WarehouseAuthSwitchNotice from '@/components/WarehouseAuthSwitchNotice'
import CookieConsentBanner from '@/components/CookieConsentBanner'
import React from 'react'
import { useLocation } from 'react-router-dom'
import { shouldDisableLayoutConstraints } from '@/utils/layout-utils'
// import SubNavigation from '@/components/SubNavigation'

const Layout = ({
  children,
  routesToDisable,
}: {
  children: React.ReactNode
  routesToDisable?: LayoutUtils.LayoutRouteLike[]
}) => {
  const { pathname } = useLocation()
  const disableMainConstraints = shouldDisableLayoutConstraints(pathname, routesToDisable)
  const isLiteRoute = pathname.startsWith('/lite')

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ScrollToTop />
      <WarehouseSelectionModal />
      <WarehouseAuthSwitchNotice />
      <SyncCartFavoritesOnLogin />
      {!isLiteRoute && <AutofillPrompt />}
      {!isLiteRoute && (
        <div className="sticky top-0 z-1001 shadow-xl">
          <Header />
          {/* <SubNavigation /> */}
        </div>
      )}
      <main
        className={
          isLiteRoute
            ? 'flex-1 w-full min-w-0 py-2 box-border'
            : disableMainConstraints
              ? 'flex-1 w-full mx-auto px-0 pt-4 pb-24 lg:pb-4 box-border'
              : 'flex-1 w-full min-w-0 container mx-auto px-4 lg:px-0 pt-4 pb-24 lg:pb-4 box-border'
        }
      >
        {children}
      </main>
      {!isLiteRoute && <Footer />}
      {!isLiteRoute && <CookieConsentBanner />}
      <ScrollUpButton />
    </div>
  )
}

export default Layout
